import Color from 'color'
import React from 'react'

import { Button, createStyles, Dialog, Theme } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { withStyles, WithStyles } from '@mui/styles'

const OrganizationDeleteWarning: React.FunctionComponent<
  OrganizationDeleteWarningProps & WithStyles<typeof styles>
> = ({ open, onClose, onDelete, classes }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this organization's content?"}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Deleting a organization content is permanent action, please proceed with caution.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onDelete} className={classes.deleteButton} color="primary" autoFocus>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
)

export type OrganizationDeleteWarningProps = {
  open: boolean
  onClose: () => void
  onDelete: () => void
}

const styles = ({ palette }: Theme) =>
  createStyles({
    deleteButton: {
      color: 'white',
      backgroundColor: palette.extra.negative,
      '&:hover': {
        backgroundColor: Color(palette.extra.negative).darken(0.2).string(),
      },
    },
  })

export default withStyles(styles)(OrganizationDeleteWarning)
